import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/styles.css';
import Builder from "./Containers/Builder/Builder";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Builder />
);
